import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AccountComponent } from './account.component';
import { AccountParametersComponent } from './account-parameters/account-parameters.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ],
    declarations: [
        AccountComponent,
        AccountParametersComponent
    ]
})
export class AccountModule { }
